import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTradingViewSteps: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"trading-view-steps"} maskId="square-filled-radius-0-stroke-1-IconTradingViewSteps"><path fillRule="evenodd" clipRule="evenodd" d="M10 3V13H9V3H10ZM5 6.99997V17H4V6.99997H5ZM20 7V17H19V7H20ZM15 11V21H14V11H15Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTradingViewSteps;
